module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "entity": _vm.message,
      "fields": _vm.fields,
      "buttons": _vm.buttons,
      "cancelAction": _vm.stopTimer
    },
    on: {
      "submit": _vm.submit
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4e8f6b81!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/command/CommandBuilder.vue
// module id = 1154
// module chunks = 2